import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const AuditRiskPage = lazy(() => import("@/features/dashboard/pages/audit-risk"));

export const Route = createFileRoute("/(app)/dashboard/audit-risk")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading…</div>}>
      <AuditRiskPage />
    </Suspense>
  ),
});
